import React, { createContext, useState, useContext } from 'react';
import translations from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('pt'); // default Portuguese

  const t = (section, key, index) => {
    // Helper function to get translation string
    // Supports nested keys and arrays (for steps, cards, etc)
    if (!translations[language]) return '';
    const sectionData = translations[language][section];
    if (!sectionData) return '';
    if (index !== undefined && Array.isArray(sectionData[key])) {
      return sectionData[key][index] || '';
    }
    return sectionData[key] || '';
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
